module.exports = __webpack_public_path__ + "static/media/master_card_default.9343beeb.svg";